"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5562],{

/***/ 55562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRewardContract; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _wagmi_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17276);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98786);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69077);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55678);
/* harmony import */ var _services_contract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26720);
/* harmony import */ var _utils_validate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68974);
/* harmony import */ var _services_events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76029);














function useRewardContract() {
    var ref = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), address = ref.address, login = ref.login;
    var switchNetworkAsync = (0,wagmi__WEBPACK_IMPORTED_MODULE_6__/* .useSwitchNetwork */ .g0)().switchNetworkAsync;
    var chain = (0,wagmi__WEBPACK_IMPORTED_MODULE_6__/* .useNetwork */ .LN)().chain;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), claiming = ref1[0], setClaiming = ref1[1];
    var claimClaimer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(epoch, reward) {
            var resp, e, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        if (claiming) {
                            return [
                                2
                            ];
                        }
                        setClaiming(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(_services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .writeContract */ .n9)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo */ .Aw), {
                                functionName: "claimClaimer",
                                args: [
                                    epoch
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .waitForTransaction */ .Mn)({
                                hash: resp.hash,
                                confirmations: 6
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isSkipError */ .D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _services_events__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit("claimClaimer", {
                            epoch: epoch,
                            address: address,
                            reward: reward
                        });
                        return [
                            3,
                            12
                        ];
                    case 10:
                        e1 = _state.sent();
                        if ((0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isUserRejectError */ .Qd)(e1)) {
                            return [
                                2
                            ];
                        }
                        console.error(e1);
                        react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .Am.error(e1.message);
                        throw new Error(e1.message);
                    case 11:
                        setClaiming(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(epoch, reward) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        claiming,
        address,
        login
    ]);
    var claimValidator = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(validatorId, reward) {
            var resp, e, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        if (claiming) {
                            return [
                                2
                            ];
                        }
                        setClaiming(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(_services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .writeContract */ .n9)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo */ .Aw), {
                                functionName: "claimValidator",
                                args: [
                                    parseInt(validatorId)
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .waitForTransaction */ .Mn)({
                                hash: resp.hash,
                                confirmations: 6
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isSkipError */ .D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _services_events__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit("claimValidator", {
                            validatorId: validatorId,
                            address: address,
                            reward: reward
                        });
                        return [
                            3,
                            12
                        ];
                    case 10:
                        e1 = _state.sent();
                        if ((0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isUserRejectError */ .Qd)(e1)) {
                            return [
                                2
                            ];
                        }
                        console.error(e1);
                        react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .Am.error(e1.message);
                        throw new Error(e1.message);
                    case 11:
                        setClaiming(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(validatorId, reward) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        claiming,
        address,
        login
    ]);
    var claimLieutenant = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(epochs, reward) {
            var resp, e, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        if (claiming) {
                            return [
                                2
                            ];
                        }
                        setClaiming(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(_services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .writeContract */ .n9)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo */ .Aw), {
                                functionName: "claimLieutenant",
                                args: [
                                    epochs.slice(0, 10),
                                    0,
                                    0
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .waitForTransaction */ .Mn)({
                                hash: resp.hash,
                                confirmations: 6
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isSkipError */ .D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _services_events__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit("claimLieutenant", {
                            epochs: epochs,
                            address: address,
                            reward: reward
                        });
                        return [
                            3,
                            12
                        ];
                    case 10:
                        e1 = _state.sent();
                        if ((0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isUserRejectError */ .Qd)(e1)) {
                            return [
                                2
                            ];
                        }
                        console.error(e1);
                        react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .Am.error(e1.message);
                        throw new Error(e1.message);
                    case 11:
                        setClaiming(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(epochs, reward) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        claiming,
        address,
        login
    ]);
    var claimStakerBatch = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(tokenIds) {
            var resp, e, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (tokenIds.length === 0) {
                            return [
                                2
                            ];
                        }
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        if (claiming) {
                            return [
                                2
                            ];
                        }
                        setClaiming(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(_services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo.chainId */ .Aw.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .writeContract */ .n9)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _services_contract__WEBPACK_IMPORTED_MODULE_3__/* .rewardContractInfo */ .Aw), {
                                functionName: "claimStakerBatch",
                                args: [
                                    tokenIds.map(function(id) {
                                        return Number(id);
                                    })
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,_wagmi_core__WEBPACK_IMPORTED_MODULE_9__/* .waitForTransaction */ .Mn)({
                                hash: resp.hash,
                                confirmations: 6
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isSkipError */ .D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _services_events__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit("claimStakerBatch", {
                            tokenIds: tokenIds,
                            address: address
                        });
                        react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.success */ .Am.success("Claim success");
                        return [
                            2,
                            true
                        ];
                    case 10:
                        e1 = _state.sent();
                        if ((0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .isUserRejectError */ .Qd)(e1)) {
                            return [
                                2
                            ];
                        }
                        console.error(e1);
                        react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .Am.error(e1.message);
                        throw new Error(e1.message);
                    case 11:
                        setClaiming(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(tokenIds) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        claiming,
        address,
        login
    ]);
    return {
        claimStakerBatch: claimStakerBatch,
        claiming: claiming,
        claimClaimer: claimClaimer,
        claimValidator: claimValidator,
        claimLieutenant: claimLieutenant
    };
}


/***/ }),

/***/ 76029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var mitt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59391);

var events = (0,mitt__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (events);


/***/ })

}]);